import { render, staticRenderFns } from "./Seperator.vue?vue&type=template&id=f6fdbd60&scoped=true&"
import script from "./Seperator.vue?vue&type=script&lang=js&"
export * from "./Seperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fdbd60",
  null
  
)

export default component.exports